// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2CAv-","legacyBtn":"MutateMid_legacyBtn__1yW_w"};